// GENERIC MODULE JS

// BASIC ACCORDION
let basicAccordions = document.querySelectorAll(
  ".accordion__container.basic .accordion__row",
);
basicAccordions.forEach((row) => {
  row.querySelector(".row__header").addEventListener("click", () => {
    row.classList.toggle("expanded");
    let body = row.querySelector(".row__body");
    if (body.style.maxHeight) {
      body.style.maxHeight = null;
    } else {
      body.style.maxHeight = body.scrollHeight + "px";
    }
  });
});

// ACCORDION BLOCKS
let accordionBlocks = document.querySelectorAll(".component__accordion");
accordionBlocks.forEach((block) => {
  let contentBlocks = block.querySelectorAll(".accordion__row");
  let controlButtons = block.querySelectorAll(
    ".accordion__row_control_list li",
  );
  contentBlocks.forEach((row, index) => {
    row.querySelector(".row__header").addEventListener("click", (content) => {
      contentBlocks[index].classList.toggle("expanded-block");
      if (controlButtons.length > 0) {
        controlButtons[index].classList.toggle("expanded-block");
      }
    });
  });

  controlButtons.forEach((button, index) => {
    button.addEventListener("click", (content) => {
      contentBlocks.forEach((block) => {
        block.classList.remove("expanded-column");
      });
      contentBlocks[index].classList.add("expanded-column");
      controlButtons.forEach((block) => {
        block.classList.remove("expanded-column");
      });
      controlButtons[index].classList.add("expanded-column");

      if (window.innerWidth > 991) {
        const rect = block.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const offset = 130;
        window.scrollTo({
          top: rect.top + scrollTop - offset,
          behavior: "smooth",
        });
      }
    });
  });
});

let inlineDropdownBlocks = document.querySelectorAll(
  ".component__inline-dropdown",
);
inlineDropdownBlocks.forEach((block) => {
  block
    .querySelector(".inline-dropdown__title")
    .addEventListener("click", (content) => {
      block.classList.toggle("expanded");
    });
});

// FLIGHT SCHEDULE
document.querySelectorAll(".grid__airline").forEach((airline) => {
  const header = airline.querySelector(".grid__airline-header");
  const body = airline.querySelector(".grid__airline-body");
  header.addEventListener("click", () => {
    const isExpanded = header.classList.toggle("expanded");
    body.style.maxHeight = isExpanded ? body.scrollHeight + "px" : null;
  });
});

// FOOTER GROUPS
let footerGroups = document.querySelectorAll(".footer__dropdown-group");
footerGroups.forEach((group) => {
  group.querySelector(".footer__dropdown-btn").addEventListener("click", () => {
    group.classList.toggle("active");
  });
});
